import { getFillOutProductCodeList, getProductCodeListFromDataLayer } from './helper'

import RemBoxReport, { SliderType, sliderTypeMap } from '#/local/service/dataLayer/pushEventRemBox'

import type { AppProductSliderUserTarget } from '#/global/types'

/**
 * ES_INIT_PRODUCT_SLIDER_USER_TARGET listener
 *
 * Povinné pro úspěšné zobrazení ProductSliderUserTarget:
 * - detail.containerId (string): ID existujícího DOM elementu pro mount slideru
 * - detail.params.itemsMaxCount (number): počet položek v jednom viewportu
 * - detail.params.sliderMaxWidth (number): maximální šířka slideru v px
 *
 * Volitelné:
 * - detail.sectionId (string): ID sekce pro mapování typu slideru a výběr dat z dataLayeru/analýzy
 * - detail.params.hasGrayBackground (boolean): šedé pozadí wrapperu
 * - detail.params.showAddToCart (boolean): zobrazení tlačítka „Do košíku“
 *
 * Další podmínky:
 * - window.ReactProductSlider musí být definován (globální mount funkce)
 * - window.dataLayer (Exponea) je použit pro posledně navštívené produkty; pokud chybí nebo event není nalezen do 10s, slider se vykreslí jen s doplňkovými údaji (nejprodávanější)
 *
 * DataLayer (Exponea) — očekávaný tvar:
 * - event: 'lastVisitedProductsAll' (HP) NEBO 'lastVisitedProductsAtSection_<sectionId>' (pro konkrétní sekci)
 * - exponea: string[] — seznam produktových kódů (hodnoty 'None' jsou ignorovány)
 *
 * Příklad push do dataLayeru:
 *   window.dataLayer = window.dataLayer || []
 *   window.dataLayer.push({
 *       event: 'lastVisitedProductsAll',
 *       exponea: ['8500081026', '1420361140', 'None', 'None', 'None', 'None', 'None', 'None', 'None', 'None']
 *   })
 */
const initProductSliderUserTarget = (event: CustomEvent<AppProductSliderUserTarget>) => {
    console.debug('initProductSliderUserTarget', event.detail)
    if (!window.ReactProductSlider) {
        console.error('[GlobalListener-ReactProductSliderUserTarget]: window.ReactProductSlider is not defined')
        return
    }
    if (event.detail.containerId === undefined) {
        console.error('[GlobalListener-ReactProductSliderUserTarget]: containerId is not defined')
        return
    }
    /** --- END VALIDATIONS --- */
    const { containerId, params, sectionId } = event.detail

    const sliderType = sectionId ? sliderTypeMap[Number(sectionId)] : SliderType.homepage

    RemBoxReport.sliderType = sliderType
    RemBoxReport.onViewSlider()
    RemBoxReport.registerOnClickEvent(containerId)

    Promise.all([
        getProductCodeListFromDataLayer(sectionId),
        getFillOutProductCodeList(sectionId),
    ]).then(([dataLayerProductCodeList, fillOutProductCodeList]) => {
        const productCodeList = [...new Set([...dataLayerProductCodeList, ...fillOutProductCodeList])].splice(0, 14)

        window.ReactProductSlider?.(containerId, {
            hasGrayBackground: true,
            productCodeList,
            ...params,
        })
    }).catch((error) => {
        console.error('[GlobalListener-ReactProductSliderUserTarget]:', error)
    })
}

export default initProductSliderUserTarget
